import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-041f3dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridcard-wrapper" }
const _hoisted_2 = { class: "gridcard-title" }
const _hoisted_3 = { class: "gridcard-items" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "gridcard-item-image" }
const _hoisted_6 = { class: "gridcard-item-title" }
const _hoisted_7 = { class: "gridcard-item-description" }


import CustomCard from "../generics/CustomCard.vue"; // anpassa path efter din struktur

interface GridItem {
	title: string;
	image: string;
	description: string;
	link: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GridCard',
  props: {
    title: null,
    items: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createBlock(CustomCard, { key: index }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              href: item.link,
              class: "gridcard-item-link"
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.image), 1),
              _createElementVNode("h3", _hoisted_6, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(item.description), 1)
            ], 8, _hoisted_4)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
}
}

})